import { styleByID, styleCreate, styleDestroy, styleList, styleUpdate } from '@/services/agency/styles.service'

export default {
	namespaced: true,
	state: {
		// SERVICE STYLE
		styleList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		style: {},

		// STATUS SERVICE STYLE
		styleStatus: 'pending',
		styleSaveStatus: 'init',
		styleDeleteStatus: 'init',
	},
	getters: {
		// SERVICE STYLE
		getStyleList(state) {
			return state.styleList
		},
		getStyle(state) {
			return state.style
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE STYLE
		getStyleDeleteStatus(state) {
			return state.styleDeleteStatus
		},
		getStyleSaveStatus(state) {
			return state.styleSaveStatus
		},
		getStyleStatus(state) {
			return state.styleStatus
		},
	},
	mutations: {
		// SERVICE STYLE
		STYLE_LIST(state, value) {
			state.styleList = value
		},
		SET_STYLE(state, value) {
			state.style = value
		},

		// STATUS SERVICE STYLE
		STYLE_STATUS(state, value) {
			state.styleStatus = value
		},
		STYLE_SAVE_STATUS(state, value) {
			state.styleSaveStatus = value
		},
		STYLE_DELETE_STATUS(state, value) {
			state.styleDeleteStatus = value
		},
	},
	actions: {
		// Service Style
		async fetchStyleList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('STYLE_STATUS', 'pending')
			commit('STYLE_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await styleList(params)
				commit('STYLE_STATUS', 'init')
				commit('STYLE_LIST', data)
				return data
			} catch (error) {
				commit('STYLE_STATUS', 'init')
				throw error
			}
		},
		async fetchStyleByID({ commit }, params) {
			commit('STYLE_STATUS', 'pending')
			try {
				const { data } = await styleByID(params)
				commit('STYLE_STATUS', 'init')
				commit('SET_STYLE', data.data)
				return data
			} catch (error) {
				commit('STYLE_STATUS', 'init')

				return error
			}
		},
		async saveNewStyle({ commit }, params) {
			commit('STYLE_SAVE_STATUS', 'pending')
			try {
				const { data } = await styleCreate(params)
				commit('STYLE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STYLE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateStyle({ commit }, params) {
			commit('STYLE_SAVE_STATUS', 'pending')
			try {
				const { data } = await styleUpdate(params)
				commit('STYLE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STYLE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteStyleByID({ commit }, params) {
			commit('STYLE_DELETE_STATUS', 'pending')
			try {
				const { data } = await styleDestroy(params)
				commit('STYLE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STYLE_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
